export default "__VITE_ASSET__4762f268__"